import { Component, Input } from '@angular/core';
import { ChannelType, IChannel } from '../../../models/ichannel';

export class LeadAnnotationViewModel {

    // data members

    name: string = '';
    value_I: number | string = '';
    value_II: number | string = '';
    value_III: number | string = '';
    value_aVR: number | string = '';
    value_aVL: number | string = '';
    value_aVF: number | string = '';
    value_V1: number | string = '';
    value_V2: number | string = '';
    value_V3: number | string = '';
    value_V4: number | string = '';
    value_V5: number | string = '';
    value_V6: number | string = '';
    value_V3R: number | string = '';
    value_V4R: number | string = '';
    value_V5R: number | string = '';
    value_V7: number | string = '';
    value_V8: number | string = '';
    value_V9: number | string = '';

    udM: string = '';

    // constructor

    constructor() {
        // This is intentional
    }
}

@Component({
    selector: 'leads-annotations',
    templateUrl: './leads-annotations.component.html',
    styleUrls: ['./leads-annotations.component.css'],
})
export class LeadsAnnotationsComponent {

    // Data Members

    private _channels: Array<IChannel> = [];
    get channels() {
        return this._channels;
    }

    @Input()
    set channels(channels) {
        this._channels = channels;

        if (channels != null && channels.length > 0) {

            this.buildChannelMap();
            this.buildAnnotations();
        }
    }

    annotations = new Array<LeadAnnotationViewModel>();

    private _channelMap = new Map<ChannelType, IChannel>();

    // Constructor

    constructor() {
        // This is intentional
    }

    // public functions

    buildAnnotations() {

        this.annotations.splice(0, this.annotations.length);

        this._channelMap.forEach((channel) => {

            channel.annotations.forEach(annotation => {

                if (this.annotations.find(leadAnnotation => leadAnnotation.name == annotation.name) == null) {

                    let newLeadAnnotation = new LeadAnnotationViewModel();
                    newLeadAnnotation.name = annotation.name;
                    newLeadAnnotation.udM = annotation.udM;

                    this.annotations.push(newLeadAnnotation);
                }
            });
        });

        if (this.annotations.length <= 0)
            return;

        for (let i = 0; i < this.annotations.length; i++) {

            this.annotations[i].value_I = this.getAnnotationValue(ChannelType.LEAD_I, this.annotations[i].name);
            this.annotations[i].value_II = this.getAnnotationValue(ChannelType.LEAD_II, this.annotations[i].name);
            this.annotations[i].value_III = this.getAnnotationValue(ChannelType.LEAD_III, this.annotations[i].name);
            this.annotations[i].value_aVR = this.getAnnotationValue(ChannelType.LEAD_AVR, this.annotations[i].name);
            this.annotations[i].value_aVL = this.getAnnotationValue(ChannelType.LEAD_AVL, this.annotations[i].name);
            this.annotations[i].value_aVF = this.getAnnotationValue(ChannelType.LEAD_AVF, this.annotations[i].name);
            this.annotations[i].value_V1 = this.getAnnotationValue(ChannelType.LEAD_V1, this.annotations[i].name);
            this.annotations[i].value_V2 = this.getAnnotationValue(ChannelType.LEAD_V2, this.annotations[i].name);
            this.annotations[i].value_V3 = this.getAnnotationValue(ChannelType.LEAD_V3, this.annotations[i].name);
            this.annotations[i].value_V4 = this.getAnnotationValue(ChannelType.LEAD_V4, this.annotations[i].name);
            this.annotations[i].value_V5 = this.getAnnotationValue(ChannelType.LEAD_V5, this.annotations[i].name);
            this.annotations[i].value_V6 = this.getAnnotationValue(ChannelType.LEAD_V6, this.annotations[i].name);
            //this.annotations[i].value_V3R = this.getAnnotationValue(ChannelType.LEAD_V3R, this.annotations[i].name);
            //this.annotations[i].value_V4R = this.getAnnotationValue(ChannelType.LEAD_V4R, this.annotations[i].name);
            //this.annotations[i].value_V5R = this.getAnnotationValue(ChannelType.LEAD_V5R, this.annotations[i].name);
            //this.annotations[i].value_V7 = this.getAnnotationValue(ChannelType.LEAD_V7, this.annotations[i].name);
            //this.annotations[i].value_V8 = this.getAnnotationValue(ChannelType.LEAD_V8, this.annotations[i].name);
            //this.annotations[i].value_V9 = this.getAnnotationValue(ChannelType.LEAD_V9, this.annotations[i].name);
        }
        ;
    }

    // private functions
    private getAnnotationValue(channelType: ChannelType, annotationName: string): number | string {

        const annotations = this._channelMap?.get(channelType)?.annotations;
        if (!annotations)
            return '---';

        const annotation = annotations.find(annotation => annotation.name == annotationName);

        return annotation?.value ?? '---';
    }

    private setChannel = (channelType: ChannelType): void => {
        const channel = this.channels.find(channel => channel.type == channelType);
        if (channel) this._channelMap.set(channelType, channel);
    };

    private buildChannelMap() {
        [ChannelType.LEAD_I,
            ChannelType.LEAD_II,
            ChannelType.LEAD_III,
            ChannelType.LEAD_AVR,
            ChannelType.LEAD_AVL,
            ChannelType.LEAD_AVF,
            ChannelType.LEAD_V1,
            ChannelType.LEAD_V2,
            ChannelType.LEAD_V3,
            ChannelType.LEAD_V4,
            ChannelType.LEAD_V5,
            ChannelType.LEAD_V6].forEach(this.setChannel);
        //this._channelMap.set(ChannelType.LEAD_V3R, this.channels.find(channel => channel.type == ChannelType.LEAD_V3R));
        //this._channelMap.set(ChannelType.LEAD_V4R, this.channels.find(channel => channel.type == ChannelType.LEAD_V4R));
        //this._channelMap.set(ChannelType.LEAD_V5R, this.channels.find(channel => channel.type == ChannelType.LEAD_V5R));
        //this._channelMap.set(ChannelType.LEAD_V7, this.channels.find(channel => channel.type == ChannelType.LEAD_V7));
        //this._channelMap.set(ChannelType.LEAD_V8, this.channels.find(channel => channel.type == ChannelType.LEAD_V8));
        //this._channelMap.set(ChannelType.LEAD_V9, this.channels.find(channel => channel.type == ChannelType.LEAD_V9));
    }
}
